import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMProgressBar } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";

/** Adds the percentage-of-budget-spent card (#2222). */
export function addPercentageOfBudgetSpentCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";

  const percentageOfBudgetSpentComponent = view.addComponent({
    component: PMProgressBar,
    layoutProps: {
      componentId: "percentageOfBudgetSpentComponent",
      labels: ["budget"],
      description:
        getLocalizedMessage(language, "showsBudgetSpent") ||
        "Shows how much of the budget is spent.",
      title: getLocalizedMessage(language, "metrics.budgetK") || "Budget (k€)",
    },
  });

  percentageOfBudgetSpentComponent.mapState(({ currentReport, language }) => {
    const percentageOfBudgetSpent =
      currentReport?.project?._calculated?.percentageOfBudgetSpent ?? 0;
    const spentBudget = currentReport?.project?.spentBudget ?? 0;
    const approvedBudget = currentReport?.project?.approvedBudget ?? 0;
    const formatKEur = (value: number) =>
      (value / 1000).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
      });

    return {
      label: getLocalizedMessage(language, "spent") || "Spent",
      title: getLocalizedMessage(language, "metrics.budgetK") || "Budget (k€)",
      topContent: `${
        getLocalizedMessage(language, "approvedBudget") || "Approved Budget"
      }: ${formatKEur(approvedBudget)}`,
      displayTextOverride: `${formatKEur(spentBudget)} (${Math.round(
        percentageOfBudgetSpent
      )}%)`,
      trackColor: "#E0E0E0",
      barColor: "#38BDF8",
      percent: percentageOfBudgetSpent,
    };
  });
  percentageOfBudgetSpentComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "projectReporting")
        .find((field) => field.fieldName === "spentBudget")?.enabled === true
  );
}
